const labelName = {
  PROJECT: "Project",
  ISSUE: "Issue",
  ISSUE_COMMENT: "Issue Comment",
  AGENDA: "Agenda",
  DECISION: "Decision",
  PROJECT_COMMENT: "Project Comment"
};

/**
 * Function to get the background color for labels on MIS Documents
 * @param label - label field coming from BE
 * @returns {string}
 */
const getLabelColor = label => {
  switch (label) {
    case "PROJECT":
      return "#F44479";
    case "DECISION":
      return "#17a2b8";
    case "ISSUE":
      return "#ff9e00";
    case "ISSUE_COMMENT":
      return "#1cbf8c";
    case "PROJECT_COMMENT":
      return "#AA5B12";
    case "AGENDA":
      return "#4E3F90";
    default:
      return "#ffffff";
  }
};

// Return The File Extension from filename coming from BE.
const getFileExtension = fileName => fileName && fileName.split(".").pop();

/**
 * Function to download the documents.
 * @param s3Url - url coming from BE.
 * @param name - name of file for download.
 */
const downloadFile = (s3Url, name) => {
  const link = document.createElement("a");
  link.href = s3Url;
  link.target = "_blank";
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Function to Filter the Documents based on Search Text entered.
 * @param documentsList - coming from MIS Reducer.
 * @param searchText - trimmed text entered in Search Input.
 */
const getSearchedResult = (documentsList = [], searchText) => {
  return documentsList.filter(item => {
    if (searchText === "") return true;
    else {
      const regex = new RegExp(searchText, "ig");
      return (
        regex.test(item.issueId) ||
        regex.test(item.projectId) ||
        regex.test(item.createdByName) ||
        regex.test(item.fileName) ||
        regex.test(item.title)
      );
    }
  });
};

export {
  getLabelColor,
  downloadFile,
  getSearchedResult,
  getFileExtension,
  labelName
};
